<template>
<div>
  <v-layout>
    <v-flex xs12 style="position:relative">
      <v-text-field v-if="editable" v-model="model" :landscape="true"></v-text-field>
      <div v-else>
        <span v-if="isBaseValid()">
          {{ getCustomPresentationValue(model) }}
        </span>
        <!-- Invalidate or advanced validtaor -->
        <v-tooltip v-else top>
          <template v-slot:activator=" { on }">
            <span ref="span" v-on="on">{{ getCustomPresentationValue(model) | notEmpty }}</span>
          </template>
          <span>{{ validation.message }}</span>
        </v-tooltip>
      </div>
      <v-icon style="position:absolute;top:5px;right:-30px;cursor:pointer;z-index:2000" @click="updateOrigin" v-if="isEdited() && editable" class="light-green--text">check</v-icon>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'
import InputHelper from '@/plugins/InputHelper'
import NumberValidator from '@/plugins/validator/number/NumberValidator'
import fieldType from '@/enums/fieldType'

export default {
  props: ["valueField", "editable", "field", "validation", "context"],
  watch: {
    editable: function(newVal) {
      if (!newVal && this.isEdited())
        this.reset();
    },
    valueField: function(newVal) {
      this.valueToShow = newVal
      this.model = this.setUpModel(newVal)
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      modelx: "",
      valueToShow: ""
    }
  },
  methods: {
    isBaseValid() {
      if (this.field.options && this.field.options.expanded)
        return false;
      return this.validation.pass
    },
    setUpModel(value) {
      return value
    },
    updateOrigin() {
      this.$emit("updateField", this.model)
    },
    isEdited() {
      return this.valueField != this.model
    },
    reset() {
      this.model = this.setUpModel(this.valueField)
    },
    getCustomPresentationValue(model) {
      if (this.canBeFormatetToDecimal(model)) {
        return Number(model).toFixed(this.field.options.fixed)
      }
      return model;
    },
    canBeFormatetToDecimal(model) {
      if (model != undefined && this.field.options != undefined && this.field.type == "number" && this.field.options.fixed != undefined) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.model = this.setUpModel(this.valueField)
    this.valueToShow = this.valueField
  },
  mounted() {
    if ((this.field.type == "number" || this.field.type == "formule") && this.field.options && this.field.options.expanded) {
      let x = new NumberValidator(this.field, this.context, this.$refs.span)
      x.matchAndValidate()
    }
  },
  mixins: [input]
}
</script>
